<template>
	<div class="animated fadeIn">
		<b-card class="card-accent-primary" no-body>
			<template v-slot:header>
				<div class="d-inline-block mt-1">
					<i class="fa-regular fa-file-import"></i> <strong>Import Patients</strong>
				</div>
			</template>
			<b-card-body>
				
		    <b-form @submit.prevent="importPatients">
				<b-row class="p-3">
					<b-col cols="12" md="5">
				      <b-form-file
				      	:disabled="importing"
				        v-model="csvFile"
				        accept=".csv"
				        placeholder="Choose a .csv file..."
				        browse-text="Browse"
				      ></b-form-file>
				    </b-col>
					<b-col cols="12" md="1">
					    <b-overlay
							:show="importing"
							rounded
							opacity="0.6"
							spinner-small
							spinner-variant="warning"
							class="d-inline-block">
							<b-button-group>
				        	<b-button :disabled="importing" variant="warning" v-b-tooltip.hover title="Import Patients" type="submit"><i class="fa-solid fa-file-csv"></i></b-button>
				        	</b-button-group>
					  	</b-overlay>
					</b-col>
					<b-col cols="12" md="1" v-if="current_import && !importing">
					   	<b-button v-if="current_import.ready && current_import.errors?.length" variant="success" v-b-tooltip.hover title="Download" @click="download"><i class="fa-solid fa-file-arrow-down"></i></b-button>
					</b-col>
					<b-col cols="12" md="1" v-if="current_import && !importing">
					   	<b-button v-if="current_import.ready" variant="danger" v-b-tooltip.hover title="Clear" @click="clear"><i class="fa-solid fa-xmark"></i></b-button>
					</b-col>

					<b-col cols="12" md="5" v-if="progress">
					    <b-progress :max="progress.total_chunks" height="2rem" variant="success" show-progress animated>
					      <b-progress-bar :value="progress.processed_chunks">
					        <span>Progress: <strong>{{ Math.round((progress.processed_chunks / progress.total_chunks) * 100) }}%</strong></span>
					      </b-progress-bar>
					    </b-progress>
					</b-col>
				</b-row>
		    </b-form>

			<b-row v-if="current_import && !importing">
			<b-col md="6">
			  <h5 class="mb-3 text-success">Imported ({{ current_import.success?.length }})</h5>
			  <b-list-group flush>
			    <b-list-group-item v-for="(patient, index) in current_import.success" :key="`success-${index}`">
			     <span :class="{'text-warning': patient.status == 'updated', 'text-success': patient.status == 'created'}">{{ patient.status }}</span>  {{ patient.name }} 
			    </b-list-group-item>
			  </b-list-group>
			</b-col>

			<b-col md="6">
			  <h5 class="mb-3 text-danger">Errors ({{ current_import.errors?.length }})</h5>
			  <b-list-group flush>
			    <b-list-group-item v-for="(msg, index) in current_import.errors" :key="`error-${index}`" variant="danger">
			      {{ msg.reason }}
			    </b-list-group-item>
			  </b-list-group>
			</b-col>
			</b-row>
			</b-card-body>
		</b-card>
	</div>
</template>
<script>
import BaseExtension from '@/views/BaseExtension'
import { mapActions, mapGetters } from 'vuex'


export default BaseExtension.extend({
	data () {
		return {
			importing: false,
			progress: null,
			current_import: null,
			pollTimer: null,
			csvFile: null,
		}
	},
	computed: {
		...mapGetters('interchange', ['getIdentifier']),
		identifier() {
			return this.getIdentifier('patients', this.user?.username)
		}
	},
	methods: {
		...mapActions('patients', ['filterPatients', 'getPatientFutureConsultations', 'getPatientLastConsultation', 'createPatientConsultation', 'importBatch', 'getCurrentImport', 'downloadErrorImportBatch', 'clearImportData']),


        async download() {
            await this.downloadErrorImportBatch(this.identifier)
            this.current_import = null
        },

        async clear() {
        	await this.clearImportData(this.identifier)
            this.current_import = null
        },

        async importPatients(type = 'csv') {
            this.importing = true
            this.current_import = null
            this.progress = null

			const formData = new FormData()
			formData.append('file', this.csvFile)
			formData.append('type', type)
			formData.append('uuid', this.identifier)

            await this.importBatch(formData)

            this.startPolling()
        },

		startPolling() {
			this.pollTimer = setInterval(() => this.checkProgress(), 500)
		},

		stopPolling() {
			if (this.pollTimer) {
				clearInterval(this.pollTimer)
				this.pollTimer = null
			}
		},

		async handleImport(payload) {
			if (payload.username === this.user?.username) {
				if (payload.uuid === this.identifier) {
					this.current_import = await this.getCurrentImport({ uuid: this.identifier})
					this.importing = false

					this.$emit("imported")
				}
			}
		},
		async checkProgress() {
		  const batch = await this.getCurrentImport({ uuid: this.identifier })

		  if (batch && !batch.ready) {
		    this.importing = true
		    this.progress = {
		      total_chunks: batch.total_chunks,
		      processed_chunks: batch.processed_chunks
		    }

		  } else {
		    this.importing = false
		    this.progress = null

		    this.stopPolling()
		  }

		  this.current_import = batch
		}
	},

	async mounted() {
		this.startPolling()
        EventBus.$on('import-batch', payload => {
            this.handleImport(payload)
        }) 
	},
	beforeDestroy() {
		EventBus.$off('import-batch')
	}
})

</script>